import { createFileRoute } from "@tanstack/react-router";
import { KnowledgeBase } from "@/components/views/knowledge/KnowledgeBase";

export const Route = createFileRoute("/knowledge/")({
  component: KnowledgeBase,
});
